export type NavLink = {
  href: string;
  label: string;
};

export const navLinks: NavLink[] = [
  { href: "/#features", label: "Features" },
  { href: "/pricing", label: "Pricing" },
  { href: "/about", label: "About" },
  { href: "/contact", label: "Contact" },
  { href: "/blog", label: "Blog" },
];

export const authLinks: NavLink[] = [
  { href: "/signin", label: "Sign in" },
  { href: "/signup", label: "Start 7-day free trial" },
];
